import { type Common } from '../common.js';
import {
  type Agent,
  type CreateValues,
  type FindAllOptions,
  type UpdateAgentValues,
} from '../models/flow/flowAgent.js';

export class API {
  common: Common;
  baseEndpoint = '/flow/agents';

  constructor(common: Common) {
    this.common = common;
  }

  async findAll(queryParams?: FindAllOptions): Promise<Agent[]> {
    const url = this.common.constructPath(this.baseEndpoint, queryParams);
    return await this.common.getJSON(url);
  }

  async findOneById(id: string): Promise<Agent> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${id}`);
    return await this.common.getJSON(url);
  }

  async create(values: CreateValues): Promise<Agent> {
    const url = this.common.constructPath(`${this.baseEndpoint}`);
    return await this.common.postJSON(url, values);
  }

  async update(agentId: string, values: UpdateAgentValues): Promise<Agent> {
    const url = this.common.constructPath(`${this.baseEndpoint}/${agentId}`);
    return await this.common.patchJSON(url, values);
  }

  getInsightsUrl(id: string): string {
    return this.common.constructPath(`${this.baseEndpoint}/${id}/insights`);
  }
}
